export default __webpack_public_path__ + "static/screeny-130-gpz-tens-to-scheda-tecnica-f40f55480d38f3c45688a1f8e89d9dc6.pdf";